import { Button } from '@chakra-ui/react';
import { Link } from 'gatsby';
import React from 'react';
import xw from 'twin.macro';
import { ImageRenderer } from './imageRenderer';
import { Video } from './video';

interface Props {
  trainingImages: any;
}

const styles = {
  heading: xw`text-3xl leading-9 tracking-tight font-extrabold sm:text-4xl sm:leading-10 mb-2`,
  subHeading: xw`mt-2 text-xl leading-7 font-semibold`,
  tag: xw`inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-indigo-200 text-black dark:text-white dark:bg-purple-600`,
};

function Component(props: Props) {
  const { trainingImages } = props;

  return (
    <div className="relative px-4 pt-6 pb-6 mx-auto sm:px-6 lg:pt-12 lg:pb-28 lg:px-8 max-w-7xl">
      <h1
        className="mb-4 text-center text--color-heading-1"
        css={[styles.heading]}
      >
        Gallery
      </h1>
      <h3 className="mb-4 font-bold text-center text-brand-blue">
        Select album
      </h3>
      <div className="grid justify-center w-full mb-12 sm:space-x-6 gap-y-4 sm:flex">
        <Button
          as={Link}
          size="md"
          to="/gallery/project-inspection"
          variant="outline"
        >
          Project Inspection
        </Button>
        <Button size="md" variant="solid">
          Training & Capacity Building
        </Button>
      </div>
      <div className="grid lg:grid-cols-2 gap-x-12">
        <div className="pt-12 pb-4 mb-8 lg:mb-20">
          <Video url="https://youtu.be/zOiRWJObev8" />
        </div>
        <div className="pt-12 pb-4 mb-8 lg:mb-20">
          <Video url="https://www.youtube.com/watch?v=pXokSHa-BuM&ab_channel=HaiderTroy" />
        </div>
        <div className="pt-12 pb-4 mb-8 lg:mb-20">
          <Video url="https://youtu.be/OtmtT7mMrsQy" />
        </div>
        <div className="pt-12 pb-4 mb-8 lg:mb-20">
          <Video url="https://youtu.be/TDAv_iIizVY" />
        </div>
        <div className="pt-12 pb-4 mb-8 lg:mb-20">
          <Video url="https://youtu.be/UOfKubuCWy8" />
        </div>
        <div className="pt-12 pb-4 mb-8 lg:mb-20">
          <Video url="https://youtu.be/t3UNRmW1y3Y" />
        </div>
        <div className="pt-12 pb-4 mb-8 lg:mb-20">
          <Video url="https://youtu.be/xlG4mZDiYrg" />
        </div>
        <div className="pt-12 pb-4 mb-8 lg:mb-20">
          <Video url="https://youtu.be/8hienCeGLgo" />
        </div>
      </div>
      <ImageRenderer images={trainingImages} />
    </div>
  );
}

export const TrainingCapacityBuildingGallery = Component;
